import { render, staticRenderFns } from "./JoinProduct.vue?vue&type=template&id=ad5316ea&scoped=true&"
import script from "./JoinProduct.vue?vue&type=script&lang=js&"
export * from "./JoinProduct.vue?vue&type=script&lang=js&"
import style0 from "styles/views/join/joinproduct.css?vue&type=style&index=0&id=ad5316ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5316ea",
  null
  
)

export default component.exports